// extracted by mini-css-extract-plugin
module.exports =  {"xxsmall":"800px","xsmall":"1000px","small":"1300px","phone-landscape-size":"500px"};